import { shiftList } from "constants/shift";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addShift = async (bodyData) => {
  try {
    const res = await API.add_shift(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getShiftList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.get_shift_list(pageNum, filters);
    dispatch({ type: shiftList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: shiftList,
      payload: error?.response?.data || error,
    });
  }
};

export const getShiftById = async (id) => {
  try {
    const res = await API.get_shift_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateShiftById = async (id, bodyData) => {
  try {
    const res = await API.edit_shift(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteShiftById = async (id) => {
  try {
    const res = await API.delete_shift_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}